import React from 'react';

import { DividerWrapper } from './styles';

interface DividerProps {
  marginAround?: string;
}

export const Divider: React.FC<DividerProps> = ({ marginAround }) => {
  return <DividerWrapper marginAround={marginAround} />;
};
